import isEmpty from 'lodash-es/isEmpty';
import { FC, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { csrfTokenCall } from 'wisestep-api';

import { useWorkspaceContext, useUserContext } from '../context';
import { getWorkspaceToken, setWorkspaceToken } from '../utils/token';
import useFeatureValidation from '../utils/useFeatureValidation';

interface IRouteGuard {
  feature?: string;
  authorities?: string[];
}

const RouteGuard: FC<IRouteGuard> = ({ children, feature, authorities }) => {
  const workspaceContext = useWorkspaceContext();
  const navigate = useNavigate();
  const isFeatureAllowed = useFeatureValidation(feature, authorities);
  const location = useLocation();
  const [featureAllowed, setFeatureAllowed] = useState<boolean | null>();
  const user = useUserContext();
  const workspaceUser = user?.workspaceUser?.authorities;
  useEffect(() => {
    (async function () {
      if (
        isEmpty(workspaceContext.id) &&
        isEmpty(getWorkspaceToken()) &&
        location.pathname !== '/workspace/list' &&
        location.pathname !== '/workspace/create-workspace' &&
        location.pathname !== '/workspace-otp' &&
        !location.pathname.includes('/data-protection') &&
        !location.pathname.includes('/subscription') &&
        !location.pathname.includes('/unsubscribe') &&
        !location.pathname.includes('/subscribed')
      ) {
        try {
          const res = await csrfTokenCall();
          if (res.status === 412) {
            navigate('/workspace-otp');
          } else if (!isEmpty(res.headers['x-workspace-token'])) {
            setWorkspaceToken(res.headers['x-workspace-token']);
          } else if (
            workspaceUser != undefined &&
            !(workspaceUser.includes('ROLE_ADMIN') || workspaceUser.includes('ROLE_SUPER_ADMIN'))
          ) {
            window.location.href = process.env.REACT_APP_URL + 'workspace/list';
          }
        } catch (e: any) {
          if (e.response.status === 412) {
            navigate('/workspace-otp');
          } else {
            navigate('/workspace/list');
          }
        }
      }
      setFeatureAllowed(isFeatureAllowed);
    })();
  }, [isFeatureAllowed, location.pathname, navigate, workspaceContext, workspaceUser]);

  return <>{featureAllowed === null || featureAllowed ? children : navigate('/')}</>;
};

export default RouteGuard;
